export const NAVIGATION = {

  // *auth pages
  AUTH_NAVIGATION: {
    LOGIN: "/",
    LOGOUT:"/logout"
  },

  // *inner pages
  INNER_NAVIGATION: {

    DASHBOARD: "/dashboard",
    CVS: "/cvs",
    ENQUIRIES: "/enquiries",
    EVENTS: "/events",
    CHATS: "/chats",
    TRANSACTION: "/transaction",

    // *masters
    MASTERS: {
      BANNER: "/banner",
      PARTNERS: "/partners",
      TEAM_MEMBERS: "/team-members",
      UPDATE_TEAM_MEMBERS: "/update-team-members",
      ADD_TEAM_MEMBERS: "/add-team-members",
      SKILL_TYPE: "/skill-types",
      SKILLS: "/skills",
      INDUSTRIES: "/industries",
      // FONTS: "/fonts",
    },
    JOBS: {
      JOBS: "/jobs",
      PENDING_JOBS: "/pending-jobs",
      UPLOAD_JOBS: "/upload-jobs",
      JOBS_DETAIL:"/jobs-detail"
    },
    MEMBER: {
      MEMBERS: "/member",
      UPDATE_MEMBER: "/update-member",
      ADD_MEMBER: "/add-member",
    },
    BLOGS: {
      BLOG_TYPES: "/blog-types",
      ADD_BLOG: "/add-blog",
      UPDATE_BLOG: "/update-blog",
      BLOGS: "/blogs",
    },
    USERS: {
      CVS: "/cvs",
      COVER_LETTER: "/cover-letter",
      USER_LIST: "/user-list"

    },
    SETTING: {
      FONTS: "/fonts",
      CHANGE_PASSWORD: "/change-password",
      CONFIGURATION: "/configration"
    },

  },
};